// extracted by mini-css-extract-plugin
export default {"container":"ApplyHeader_container__Cfr5j","description":"ApplyHeader_description__dacYD"};